export class CoordinateMapper {
  static canvasToScreen(x, y, canvasRef, canvasScale) {
    if (!canvasRef.current) return { x: 0, y: 0 };

    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: rect.left + x * canvasScale,
      y: rect.top + y * canvasScale
    };
  }

  static screenToCanvas(clientX, clientY, canvasRef, canvasScale) {
    if (!canvasRef.current) return { x: 0, y: 0 };

    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: (clientX - rect.left) / canvasScale,
      y: (clientY - rect.top) / canvasScale
    };
  }

  static getCanvasRect(canvasRef) {
    if (!canvasRef.current) return null;
    return canvasRef.current.getBoundingClientRect();
  }

  static focusNode(nodeRect, scrollContainerRef, canvasRef, canvasScale, rootW, rootH) {
    if (!scrollContainerRef.current || !canvasRef.current) return;

    // Calculate target center relative to the canvas content (unscaled)
    const targetCenterX = nodeRect.x + nodeRect.width / 2;
    const targetCenterY = nodeRect.y + nodeRect.height / 2;

    // Scale to current zoom level
    const scaledX = targetCenterX * canvasScale;
    const scaledY = targetCenterY * canvasScale;

    // Dimensions of the viewport
    const viewportW = scrollContainerRef.current.clientWidth;
    const viewportH = scrollContainerRef.current.clientHeight;

    // Large container dimensions
    const largeContainer = scrollContainerRef.current.children[0];
    if (!largeContainer) return;

    const largeW = largeContainer.scrollWidth;
    const largeH = largeContainer.scrollHeight;

    // Canvas visual dimensions
    const canvasVisualW = rootW * canvasScale;
    const canvasVisualH = rootH * canvasScale;

    // Offset of canvas top-left in the large container
    const canvasOffsetX = Math.max(0, (largeW - canvasVisualW) / 2);
    const canvasOffsetY = Math.max(0, (largeH - canvasVisualH) / 2);

    // Target position relative to scrollable content (large container)
    const targetInLargeX = canvasOffsetX + scaledX;
    const targetInLargeY = canvasOffsetY + scaledY;

    scrollContainerRef.current.scrollTo({
      left: targetInLargeX - viewportW / 2,
      top: targetInLargeY - viewportH / 2,
      behavior: 'smooth'
    });
  }
}
